import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

import {
  NavBar,
  HeadingDisplay,
  LoaderIndicator,
  HelperViewContextual,
  BaseText,
  Row,
  SpinnerLoader,
  BaseIcon
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BackButton } from '@/modules/common/components/buttons/BackButton';

import {
  getIncomeReportYears,
  getIncomeReport,
  IIncomeReportYears
} from '@/modules/investments/services/investments';
import { forceFileDownload } from '@/modules/common/helpers/force-download';


export default /*#__PURE__*/_defineComponent({
  __name: 'IncomeReport',
  setup(__props) {

const router = useRouter();

const hasError = ref(false);
const isLoading = ref(false);
const incomeReportYears = ref<IIncomeReportYears[]>([]);

function onBack() {
  router.push({ name: 'home' });
}

const isEmpty = computed(() => {
  return Boolean(incomeReportYears.value.length === 0);
});

const helperViewProps = computed(() => {
  const errorProps = {
    'generic-error': true,
    buttonLabel: 'Tentar novamente'
  };

  const emptyProps = {
    icon: 'ED0030',
    description: 'Você não possui informes de rendimentos',
    context: 'neutral'
  };

  return hasError.value ? errorProps : emptyProps;
});

async function fetchIncomeReportYears() {
  try {
    hasError.value = false;
    isLoading.value = true;

    const data = await getIncomeReportYears();

    incomeReportYears.value = data;
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

async function onClickDownload(year: number, type: string) {
  try {
    toggleItemLoading(year, type);

    const report = await getIncomeReport(year, type);

    notify({
      group: 'wrn-notifications',
      text: 'Download iniciado',
      type: NotificationTypes.success
    });

    forceFileDownload({
      data: report,
      type: 'application/pdf',
      fileName: `${type}-${year}.pdf`
    });
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Houve um problema ao iniciar o download',
      type: NotificationTypes.error
    });
  } finally {
    toggleItemLoading(year, type);
  }
}

function toggleItemLoading(year: number, type: string) {
  const reportYearIndex = incomeReportYears.value.findIndex(
    detail => detail.year === year
  );

  const reportIndex = incomeReportYears.value[
    reportYearIndex
  ].reports.findIndex(report => report.type.value === type);

  incomeReportYears.value[reportYearIndex].reports[reportIndex].isLoading =
    !incomeReportYears.value[reportYearIndex].reports[reportIndex].isLoading;
}

onMounted(() => {
  fetchIncomeReportYears();
});

return { __sfc: true,router, hasError, isLoading, incomeReportYears, onBack, isEmpty, helperViewProps, fetchIncomeReportYears, onClickDownload, toggleItemLoading, NavBar, HeadingDisplay, LoaderIndicator, HelperViewContextual, BaseText, Row, SpinnerLoader, BaseIcon, NebraskaColors, BackButton }
}

})